import { useState } from 'react';

interface Review {
  id: number;
  name: string;
  location: string;
  text: string;
  image: string;
}

export function ClientReviewsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviews: Review[] = [
    {
      id: 1,
      name: 'Layla M.',
      location: 'Doha',
      text: `"Partnering with this studio was a turning point for our brand identity. The team's ability to blend Parisian heritage with a sharp, editorial edge resulted in a campaign that truly resonates with our global audience. Every shot feels like a work of art."`,
      image: 'https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/44ecc265296b909eb710cb0c6bc68bd6.jpeg'
    },
    {
      id: 2,
      name: 'Omar A.',
      location: '',
      text: `Expertly managed and creatively brilliant. They turned our Riyadh-based brand into a Parisian fashion editorial. Exceptional work`,
      image: 'https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/5360325b208f66a9677e6d25db006811.jpeg'
    },
    {
      id: 3,
      name: 'Sarah B.',
      location: 'Riyadh',
      text: `"The professionalism of PRVCREATIVE is unmatched. For our luxury handbag launch, they masterfully blended Parisian chic with our Qatari heritage with rare subtlety. Their attention to detail and the speed of delivery for the final retouched visuals were impressive. They truly understand the demands of international high-end brands."`,
      image: 'https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/c7de89a820056ab1d137de927269eb5f.jpeg'
    }
  ];

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const currentReview = reviews[currentIndex];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-serif font-light text-gray-900 mb-4">
            Client Testimonials
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image à gauche */}
          <div className="relative h-[600px] lg:h-[700px]">
            <img
              src={currentReview.image}
              alt={currentReview.name}
              className="w-full h-full object-cover object-top transition-opacity duration-500"
            />
          </div>

          {/* Contenu à droite */}
          <div className="flex flex-col justify-center">
            <div className="mb-8">
              <h3 className="text-2xl md:text-3xl font-serif font-light text-gray-900 mb-2">
                {currentReview.name}
              </h3>
              <p className="text-base text-gray-600 font-serif italic">
                {currentReview.location}
              </p>
            </div>

            <div className="mb-12">
              <p className="text-base md:text-lg leading-relaxed text-gray-700 font-serif italic">
                {currentReview.text}
              </p>
            </div>

            {/* Navigation */}
            <div className="flex items-center justify-between">
              <button
                onClick={handlePrevious}
                className="w-12 h-12 flex items-center justify-center border border-gray-300 hover:border-gray-800 hover:bg-gray-800 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Previous review"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>

              <div className="flex items-center gap-2">
                <span className="text-2xl font-serif text-gray-900">
                  {String(currentIndex + 1).padStart(2, '0')}
                </span>
                <span className="text-2xl font-serif text-gray-400">/</span>
                <span className="text-2xl font-serif text-gray-400">
                  {String(reviews.length).padStart(2, '0')}
                </span>
              </div>

              <button
                onClick={handleNext}
                className="w-12 h-12 flex items-center justify-center border border-gray-300 hover:border-gray-800 hover:bg-gray-800 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Next review"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}